module.exports = __webpack_public_path__ + "img/kairos-afrika-logo.05069344.png";